module.exports = __webpack_public_path__ + "static/img/recommend.4bf7e54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/recommend.png
// module id = X4z0
// module chunks = 1